
import { createReducer } from 'reducers';
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { createStructuredSelector } from 'reselect';
import {
    SESSION_LOGOUT,
} from 'components/Session/SessionActionTypes';
import {
     SHOW_VIDEO,
     CLOSE_VIDEO,
} from './BannerActionTypes';

export const bannerInitialState = Map({
  video: false,
});

const handlers = {
  [SHOW_VIDEO](state) {
    return state.merge({
      video: true,
    });
  },
  [CLOSE_VIDEO](state) {
    return state.merge({
      video: false,
    });
  },
  [SESSION_LOGOUT](state) {
    return state.merge({
      video: false,
    });
  },
};

export const banner = createReducer(bannerInitialState, handlers);

// LOGIN SELECTOR
const video = state => state.banner.get('video');

export const bannerSelector = createStructuredSelector({
  video,
});



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.redux.js